import $ from 'jquery';
import '../../common/js/lazyload/lazyload';
import 'resize-end';
import brandhubSlickSlider from '../../common/js/slickslider/slickslider';
import youtubeplayer from '../../common/js/youtubeplayer/youtubeplayer';
import '../../common/js/dropdownbutton/dropdownbutton';
import mp4player from '../../common/js/mp4player/mp4player';
import browserdetect from '../../common/js/browserdetect/browserdetect';

export const CSS_CLASS = 'brandhub-slider-section';

export default class Slider {
  elem;
  listElem;
  listElems;
  videoContainer;
  closeButton;
  ytPlayer;
  mp4Player;
  mp4playerIsAutoplay = false;
  mp4playerStartHeight = 0;
  currentSliderItem;
  sliderItemNr;

  constructor (elem) {
    this.elem = $(elem);
  }

  init () {
    this.listElem = this.elem.find('.brandhub-slider-list');
    this.listElems = this.listElem.find('.brandhub-slider-item');
    this.origH = this.elem.height();
    this.initEvents();
    this.initBrandhubSliderVideoButtons();
    this.initBrandHubSlider();
    this.initMP4Video();
    this.initTracking();
    this.initColumnsPagination();
  }

  initEvents () {
    document.addEventListener('brandhub-video-close', () => {
      if (this.ytPlayer) {
        this.unloadBrandHubSliderVideo();
      } else if (this.mp4Player) {
        this.closeMP4Video();
      }
    });
  }

  initBrandhubSliderVideoButtons () {
    this.listElems.each((index, sliderItem) => {
      const sliderElem = this.elem;
      // bind click to play video
      $(sliderItem).find('a[data-js-video-youtube-id], .brandhub-video-icon[data-js-video-youtube-id]').off('click').bind('click', (evt) => {
        evt.preventDefault();
        const clickedVideoButtonElem = $(evt.currentTarget);
        const sliderItemElem = $(sliderItem);
        this.loadBrandHubSliderVideo(clickedVideoButtonElem, sliderItemElem, sliderElem);
      });
    });
  }

  loadBrandHubSliderVideo (clickedVideoButtonElem, sliderItemElem, sliderElem) {
    // pause slick autoplay
    if (this.listElem.length > 1 && this.listElem.slick) {
      this.listElem.slick('slickPause');
    }

    // init video, but do not start to play it, because we have to animate first
    this.ytPlayer = youtubeplayer(sliderElem, {
      ytId: clickedVideoButtonElem.attr('data-js-video-youtube-id'),
    });

    // video has been loaded and animation is finished so autoplay video
    sliderElem.find('.brandhub-video-iframe').on('brandhubYTPlayerReady', (event) => {
      this.listElem.animate({ opacity: 0 }, 500, () => {
        this.ytPlayer.play();
        window.setTimeout(() => {
          // get container again, after it has been converted to an iframe
          // this.ytPlayer = ytPlayer
          this.videoContainer = $(`#${event.target.id}`);
          this.closeButton = sliderElem.find('.brandhub-icon-close');
          this.videoContainer.animate({ opacity: 1 }, 500, () => {
            this.closeButton.animate({ opacity: 1 }, 500);
            this.currentSliderItem = sliderItemElem;
            this.closeButton.on('click', () => this.unloadBrandHubSliderVideo());
            this.listElem.on('beforeChange', () => this.unloadBrandHubSliderVideo());
          });
        }, 200);
      });
    });
  }

  unloadBrandHubSliderVideo () {
    this.closeButton.off('click', () => this.unloadBrandHubSliderVideo());
    this.listElem.off('beforeChange', () => this.unloadBrandHubSliderVideo());

    if (!this.ytPlayer) {
      return;
    }

    this.closeButton.animate({ opacity: 0 }, 300);
    this.videoContainer.animate({ opacity: 0 }, 300, () => {
      this.ytPlayer.pause();
      this.listElem.animate({ opacity: 1 }, 500, () => {
        this.ytPlayer.destroy();
        this.ytPlayer = null;
        this.videoContainer.remove();
        this.closeButton.remove();
        // animate height
        this.elem.animate({
          height: this.origH,
        }, 500, () => {
          this.elem.css({
            height: '',
          });
          this.elem.removeClass('video-is-playing');
        });

        // continue slick autoplay
        this.listElem.slick('slickPlay');
      });
    });
  }

  initMP4Video () {
    this.listElems.each((index, sliderItem) => {
      const mp4Link = $(sliderItem).is('[data-js-video-mp4]');
      if (mp4Link) {
        const $video = $(sliderItem).find('video');
        if ($video && $video.is('[autoplay]') && !this.elem.is('.brandhub-variant-columns-gallery')) {
          this.mp4Player = mp4player($video, {
            lazyLoadPlayer: false,
            ratio: '16:9',
          });
          this.mp4playerIsAutoplay = true;
          if (this.listElems.length === 1) {
            const $responsive = $(sliderItem).find('.embed-responsive');
            $responsive.removeClass();
            $responsive.addClass('embed-responsive embed-responsive-16by9');
          }
        } else {
          const $button = $(sliderItem).find('.brandhub-slider-link')
            .add($(sliderItem).find('.brandhub-video-icon'));
          if ($button.length) {
            $button.off('click').bind('click', (evt) => {
              evt.preventDefault();
              const $clonedVideo = $(sliderItem).find('video').clone();
              const width = $(sliderItem).width();
              this.showMP4Video($clonedVideo, width);
            });
          }
        }
      }
    });
  }

  getVideoElem () {
    return this.listElem.parent().children('.plyr--video');
  }

  showMP4Video ($video, width) {
    if (this.listElem.length > 1 && this.listElem.slick) {
      this.listElem.slick('slickPause');
    }
    this.mp4playerStartHeight = this.listElem.height();
    $video.appendTo(this.listElem.parent());
    this.mp4Player = mp4player($video, {
      lazyLoadPlayer: false,
      ratio: '16:9',
    });
    this.mp4playerIsAutoplay = false;
    // simulate user interaction for safari
    if (browserdetect.isSafari) {
      this.mp4Player.player.play().then(() => this.mp4Player.player.pause());
    }

    const $videoEl = this.getVideoElem();
    $videoEl.css({ height: this.mp4player, opacity: 0, padding: 'inherit' });
    const height = (width / 16) * 9;
    this.listElem.animate({ opacity: 0 }, 500, () => {
      this.listElem.hide();
    });
    $videoEl.animate({ height }, 500, () => {
      $videoEl.animate({ opacity: 1 }, 500, () => {
        this.mp4Player.play();
        const $closeIcon = $('<span class="brandhub-icon brandhub-icon-close" style="opacity: 1;"></span>');
        this.listElem.parent().append($closeIcon);
        $closeIcon.off('click').bind('click', () => {
          this.closeMP4Video();
        });
      });
    });
  }

  closeMP4Video () {
    if (!this.mp4Player || this.mp4playerIsAutoplay) {
      return;
    }

    const $videoEl = this.getVideoElem();
    const currentHeight = $videoEl.height();
    $videoEl.animate({ opacity: 0 }, 500, () => {
      $videoEl.hide();
      this.listElem.parent().children('.brandhub-icon').remove();
      this.listElem.css({
        display: 'block',
        'background-color': 'transparent',
      });
      this.listElem.height(currentHeight);
      this.listElem.animate({ height: this.mp4playerStartHeight, opacity: 1 }, 500, () => {
        this.getVideoElem().remove();
        this.listElem.slick('slickPlay');
        if (this.listElems.length === 1) {
          this.listElem.css({ height: 'inherit' });
          this.listElem.find('.slick-track').css({ width: 'inherit' });
        }
        this.mp4Player = null;
      });
    });
  }

  get isColumnsGallery () {
    return this.elem.hasClass('brandhub-variant-columns-gallery');
  }

  scrollTop (offsetTop, duration) {
    $('html, body').animate({
      scrollTop: offsetTop,
    }, duration);
  }

  initBrandHubSlider () {
    if (this.listElem.hasClass('slick-initialized')) {
      return;
    }

    this.initSliderPagination();

    // init of slick slider
    brandhubSlickSlider.init(this.listElem, this.getSlickOptions());

    // set arrow color
    if (!this.isColumnsGallery) {
      this.listElem.on('afterChange', () => {
        this.updateArrowsColor();
      });
      setTimeout(() => {
        this.updateArrowsColor();
      }, 2500);
    }

    // set brandhub-variant-gallery-without-title-and-text class
    if (this.elem.hasClass('brandhub-variant-gallery')) {
      if (this.listElem.find('.brandhub-slider-item-overlay').length === 0) {
        this.elem.addClass('brandhub-variant-gallery-without-title-and-text');
      }
    }

    this.setupAchorLinks();

    // on resizeend trigger lazyLoadXT
    $(window).on('resizeend', () => {
      this.elem.find('img').lazyLoadXT();
    });

    // for delayed initial transition
    setTimeout(() => {
      this.listElems.addClass('ready');
    }, 750);
  }

  /**
   * Setup anchor links - trigger an animated scrolling (but only if it is really an anchor link and not only a hash)
   */
  setupAchorLinks () {
    this.listElem.find('a.btn').each((index, elem) => {
      const btnElem = $(elem);
      const btnHref = btnElem.attr('href');
      if (btnHref && btnHref.indexOf('#') === 0 && btnHref !== '#') {
        btnElem.on('click', (evt) => {
          evt.preventDefault();
          const targetAnchor = $(btnElem.attr('href'));
          const offsetTop = targetAnchor.offset().top;
          this.scrollTop(offsetTop, 1000);
          // if offset changes while scrolling down, because of lazy loaded images, try to adjust it
          // while still scrolling
          const adjustScrolling = () => {
            const newOffsetTop = targetAnchor.offset().top;
            if (Math.abs(newOffsetTop - offsetTop) > 15) {
              this.scrollTop(newOffsetTop, 500);
            }
          };
          setTimeout(() => adjustScrolling(), 500);
          setTimeout(() => adjustScrolling(), 1000);
          return false;
        });
      }
    });
  }

  updateArrowsColor () {
    if (this.listElem.find('.slick-active').hasClass('brandhub-text-color-brand-primary')) {
      this.listElem.find('.slick-arrow').addClass('black-arrow');
    } else {
      this.listElem.find('.slick-arrow').removeClass('black-arrow');
    }
  }

  getSlickOptions () {
    let slickOptions = {
      infinite: true,
      autoplay: true,
      dots: false,
      rows: 0,
      autoplaySpeed: 6000,
      nextArrow: `<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button" style="display: block">
                    <span class="brandhub-icon brandhub-icon-arrow-right"></span>
                </button>`,
      prevArrow: `<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button" style="display: block">
                    <span class="brandhub-icon brandhub-icon-arrow-left"></span>
                </button>`,
    };

    slickOptions.autoplay = this.elem.hasClass('brandhub-slider-with-autoplay');
    if (this.isColumnsGallery) {
      const slidesToShow = this.elem.hasClass('brandhub-slider-three-col') ? 3 : 2;
      slickOptions = $.extend(slickOptions, {
        dots: true,
        slidesToShow,
        slidesToScroll: 1,
        customPaging: (slider, i) => $('<button type="button" />').html(`<span class="brandhub-slider-item-nr"> ${i + 1}</span>`),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
            },
          },
        ],
      });
    }
    return slickOptions;
  }

  initSliderPagination () {
    this.sliderItemNr = this.elem.find('.brandhub-slider-item-nr');
    if (this.elem.hasClass('brandhub-variant-gallery')) {
      const itemElems = this.listElem.find('.brandhub-slider-item');
      if (itemElems.length >= 2) {
        this.sliderItemNr.each((index, elem) => {
          $(elem).append(`/${itemElems.length}`);
        });
      } else {
        this.sliderItemNr.each((index, elem) => {
          $(elem).html('&nbsp;');
        });
      }
    }
  }

  initTracking () {
    const trackedLinks = this.elem.find('a, button');
    trackedLinks.attr('data-analytics-section-headline', this.elem.attr('data-analytics-section-headline'));
    trackedLinks.attr('data-analytics-section-navigation-anchor-id', this.elem.attr('data-analytics-section-navigation-anchor-id'));
  }

  initColumnsPagination () {
    if (this.isColumnsGallery) {
      const itemElems = this.listElems;
      if (itemElems.length >= 2) {
        this.sliderItemNr.each((index, elem) => {
          if (elem.innerText.includes('/')) {
            return;
          }
          $(elem).append(`/${itemElems.length}`);
        });
      } else {
        this.sliderItemNr.each((index, elem) => {
          $(elem).html('&nbsp;');
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./custom_dependencies/brandhub-embxp-frontend/daimler-brandhub-modules/daimler-brandhub-design/daimler-brandhub-design-package/frontend/src/components/slider/Slider.js